<script>
  import { onMount } from 'svelte';
  import { push } from 'svelte-spa-router';
  import { getApiBase } from './apiBase.js';
  import { readInboxLogin } from './inbox/navigation.js';

  let formData = {
    username: '',
    password: ''
  };

  let errorMessage = ''; // Add a variable to store error messages
  // let isGoogleLoading = false; // Loading state for Google login - COMMENTED OUT
  
  // Check if user is already logged in and handle redirect
  onMount(() => {
    const token = localStorage.getItem('jwtToken');
    const expiry = localStorage.getItem('jwtExpiry');
    
    const urlParams = new URLSearchParams(window.location.search);
    const redirectTo = urlParams.get('redirect');
    const inboxLogin = readInboxLogin(window.location.hash);
    // A server-rejected token may still have a future local expiry. Do not bounce
    // back to the protected thread before the user has actually reauthenticated.
    if (inboxLogin?.forceLogin) return;
    
    // Check if token exists and is not expired
    if (token && expiry && Date.now() < parseInt(expiry)) {
      if (inboxLogin) { push(inboxLogin.target); return; }
      // User is already logged in, check for redirect parameter
      
      if (redirectTo === 'invoice') {
        console.log('AboutPage onMount - redirecting to invoice (already logged in)');
        // Set a flag to indicate user was redirected to invoice page
        sessionStorage.setItem('redirectedToInvoice', 'true');
        // Redirect to invoice page
        push('/invoice');
        return;
      } else if (redirectTo === 'reschedule') {
        console.log('AboutPage onMount - redirecting to schedule with reschedule tab (already logged in)');
        // If they came from a reschedule notification, redirect to schedule page with reschedule tab
        push('/schedule?tab=reschedule');
        return;
      } else {
        console.log('AboutPage onMount - redirecting to login-greeting (already logged in)');
        // Redirect to normal logged-in page
        push('/login-greeting');
        return;
      }
    }

    // Initialize Google Sign-In - COMMENTED OUT
    // initializeGoogleSignIn();
  });

  // GOOGLE SIGN-IN FUNCTIONS - READY FOR TESTING
  /*
  function initializeGoogleSignIn() {
    // Load Google Sign-In script
    if (!window.google) {
      const script = document.createElement('script');
      script.src = 'https://accounts.google.com/gsi/client';
      script.onload = () => {
        console.log('Google Sign-In script loaded');
        setupGoogleSignIn();
      };
      document.head.appendChild(script);
    } else {
      setupGoogleSignIn();
    }
  }
  */

  /*
  function setupGoogleSignIn() {
    if (window.google) {
      window.google.accounts.id.initialize({
        client_id: '39353963038-t5v1f98vbdkdmptbd8mkkp1bhijd1u9i.apps.googleusercontent.com',
        callback: handleGoogleSignIn,
        auto_select: false,
        cancel_on_tap_outside: false
      });
      
      // Render the sign-in button
      window.google.accounts.id.renderButton(
        document.getElementById('google-signin-button'),
        {
          theme: 'outline',
          size: 'medium',
          text: 'signin_with',
          locale: 'lt'
        }
      );
    }
  }
  */

  /*
  async function handleGoogleSignIn(response) {
    console.log('Google Sign-In response:', response);
    isGoogleLoading = true;
    errorMessage = '';

    try {
      const result = await fetch('/studentplayground/api/google-oauth/', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          token: response.credential
        })
      });

      const data = await result.json();
      console.log('Backend response:', data);

      if (result.ok) {
        // Store JWT token
        localStorage.setItem('jwtToken', data.access);
        const decodedToken = parseJwt(data.access);
        localStorage.setItem("jwtExpiry", decodedToken.exp * 1000);
        window.dispatchEvent(new Event('tutory:session-changed'));
        
        // Check for redirect parameter
        const urlParams = new URLSearchParams(window.location.search);
        const redirectTo = urlParams.get('redirect');
        
        console.log('Google login success - redirect param:', redirectTo);
        
        if (redirectTo === 'invoice') {
          console.log('Google login success - redirecting to invoice');
          sessionStorage.setItem('redirectedToInvoice', 'true');
          push('/invoice');
        } else if (redirectTo === 'reschedule') {
          console.log('Google login success - redirecting to schedule with reschedule tab');
          push('/schedule?tab=reschedule');
        } else {
          console.log('Google login success - redirecting to login-greeting');
          push('/login-greeting');
        }
      } else {
        errorMessage = data.error || 'Google login failed';
      }
    } catch (error) {
      console.error('Google login error:', error);
      errorMessage = 'Connection failed. Please try again.';
    } finally {
      isGoogleLoading = false;
    }
  }
  */
  
  export function parseJwt(token) {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
        atob(base64)
            .split('')
            .map(function (c) {
                return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
            })
            .join('')
    );

    return JSON.parse(jsonPayload);
}
  async function handleSubmit(event) {
    event.preventDefault();
    errorMessage = ''; // Reset error message before new submission

    // Log device and browser information for debugging
    console.log('=== LOGIN DEBUG INFO ===');
    console.log('User Agent:', navigator.userAgent);
    console.log('Platform:', navigator.platform);
    console.log('Online:', navigator.onLine);
    console.log('Connection:', navigator.connection ? {
      effectiveType: navigator.connection.effectiveType,
      downlink: navigator.connection.downlink,
      rtt: navigator.connection.rtt
    } : 'Not available');

    // Create a timeout wrapper for fetch
    const fetchWithTimeout = (url, options, timeout = 10000) => {
      return Promise.race([
        fetch(url, options),
        new Promise((_, reject) =>
          setTimeout(() => reject(new Error('Request timeout')), timeout)
        )
      ]);
    };

    // Retry logic for mobile networks
    const maxRetries = 3;
    let retryCount = 0;

    while (retryCount < maxRetries) {
      try {
        console.log(`Sending request to token endpoint... (attempt ${retryCount + 1})`);
        
        const apiBase = getApiBase();
        const response = await fetchWithTimeout(`${apiBase}/studentplayground/api/token/`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(formData)
        }, 15000); // 15 second timeout for mobile

        console.log('Received response:', response); // Log the entire response object

        if (response.ok) {
            console.log('Response OK:', response.status);
            
            const data = await response.json();
            
            // The JWT token is typically in data.access
            if (data.access) {
                const token = data.access;
                const decodedToken = parseJwt(token);

                // Save the token to localStorage
                localStorage.setItem('jwtToken', data.access);
                localStorage.setItem("jwtExpiry", decodedToken.exp * 1000);
                window.dispatchEvent(new Event('tutory:session-changed'));
                const inboxLogin = readInboxLogin(window.location.hash);
                if (inboxLogin) { push(inboxLogin.target); return; }
                
                // Check if there's a redirect parameter in the URL
                const urlParams = new URLSearchParams(window.location.search);
                const redirectTo = urlParams.get('redirect');
                
                console.log('Login success - redirect param:', redirectTo);
                
                if (redirectTo === 'invoice') {
                    console.log('Login success - redirecting to invoice');
                    // Set a flag to indicate user was redirected to invoice page
                    sessionStorage.setItem('redirectedToInvoice', 'true');
                    // If they came from a balance notification, redirect to invoice page
                    push('/invoice');
                } else if (redirectTo === 'reschedule') {
                    console.log('Login success - redirecting to schedule with reschedule tab');
                    // If they came from a reschedule notification, redirect to schedule page with reschedule tab
                    push('/schedule?tab=reschedule');
                } else {
                    console.log('Login success - redirecting to login-greeting');
                    // If it's not the first login, redirect to the regular greeting page
                    push('/login-greeting');
                }
                return; // Success, exit retry loop
            }
        } else {
            console.warn('Response NOT OK:', response.status);
            
            const errorData = await response.json();
            console.log('Error data:', errorData); // Log the error data from the response
            
            errorMessage = errorData.message || "Neteisingi prisijungimo duomenys" || 'Incorrect username or password'; // Set error message
            return; // Don't retry on authentication errors
        }
      } catch (error) {
        console.error(`Fetch error (attempt ${retryCount + 1}):`, error); // Log any fetch errors that occur
        
        retryCount++;
        if (retryCount >= maxRetries) {
          errorMessage = `Connection failed after ${maxRetries} attempts. Please check your internet connection and try again.`;
        } else {
          // Wait before retrying (exponential backoff)
          await new Promise(resolve => setTimeout(resolve, 1000 * retryCount));
          console.log(`Retrying in ${1000 * retryCount}ms...`);
        }
      }
    }

    console.log('Error message:', errorMessage); // Log the final error message
}

  function getCsrfToken() {
    return document.cookie.split('; ')
      .find(row => row.startsWith('csrftoken='))
      ?.split('=')[1];
  }

  function handleForgotPassword() {
    push('/forgot-password');
  }

  function handleForgotPasswordKeydown(event) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      handleForgotPassword();
    }
  }

  
</script>

<style>
  .background {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: -1;
    background-color: #fffffa;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .content {
    position: relative;
    z-index: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    max-width: 400px; /* Adjust as needed */
    margin: 40px auto
  }

  div {
    padding: 30px;
  }

  form {
    width: 90%;
    padding: 20px;
    background-color: #eeebdb;
    border-radius: 10px;
    box-shadow: 0 0 15px rgba(0, 0, 0, 0.2);
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  label {
    display: block;
    margin-top: 10px;
    font-weight: bold;
    align-self: baseline;
    color:#14695b;
  }

  input, button {
    width: -webkit-fill-available;
    display: block;
    padding: 10px;
    margin-top: 10px;
    border-radius: 5px;
    border: 1px solid #ddd;
  }

  button {
    background-color: #fab45a;
    color: #674a25;
    font-weight: bold;
    border: 1px solid;
    border-color: #674a25;
    height:50px;
  }

  button:hover {
    background-color: #674a25;
    color:#fab45a;
    border-color:#fab45a;
  }

  
  .error-message {
    color: red;
    font-weight: bold;
    margin-top: 10px;
    text-align: center;
  }

  .forgot-password {
    margin-top: 15px;
    text-align: center;
    color: #14695b;
    font-size: 14px;
    cursor: pointer;
    text-decoration: underline;
  }

  .forgot-password:hover,
  .forgot-password:focus {
    color: #fab45a;
    outline: none;
    text-decoration: none;
    font-weight: bold;
  }

  .divider {
    display: flex;
    align-items: center;
    margin: 15px 0 10px 0;
    color: #14695b;
    font-size: 14px;
  }

  .divider::before,
  .divider::after {
    content: '';
    flex: 1;
    height: 1px;
    background: #14695b;
  }

  .divider::before {
    margin-right: 10px;
  }

  .divider::after {
    margin-left: 10px;
  }

  .google-signin-container {
    width: 100%;
    display: flex;
    justify-content: center;
    margin: 10px 0 5px 0;
  }

  #google-signin-button {
    width: 100%;
    max-width: 100%;
  }

  /* Override Google's default button styling to reduce margins */
  :global(.google-signin-container iframe) {
    margin: 0 !important;
    padding: 0 !important;
  }

  :global(.google-signin-container div[data-type="standard"]) {
    margin: 0 !important;
    padding: 0 !important;
  }

  .loading-text {
    text-align: center;
    color: #14695b;
    font-style: italic;
    margin-top: 10px;
  }

  @media (max-aspect-ratio: 4/3) {
    .content {
      width: calc(100%-40px);
    }
  }

  @media (min-aspect-ratio: 4/3) {
    .content {
      width: 80%;
      margin: 40px auto 0;
    }
  }
</style>

<div class="background"></div>

<div class="content">
  <form on:submit={handleSubmit}>
    <img src="/static/images/Tutory Logo Black 1.png" alt="TUTORY Logo" class="logo" style="max-width: 200px;">
    
    <!-- Google Sign-In Section - COMMENTED OUT -->
    <!--
    <div class="google-signin-container">
      <div id="google-signin-button"></div>
    </div>
    
    {#if isGoogleLoading}
      <div class="loading-text">Prijungiama per Google...</div>
    {/if}
    
    <div class="divider">arba</div>
    -->
    
    <!-- Traditional Login Form -->
    <label for="username">Vartotojo vardas</label>
    <input id="username" name="username" autocomplete="username" type="text" bind:value={formData.username} placeholder="Username">
    <label for="password">Slaptažodis</label>
    <input id="password" name="password" autocomplete="current-password" type="password" bind:value={formData.password} placeholder="Password">
    <button type="submit">Prisijungti</button>
    {#if errorMessage}
      <div class="error-message">{errorMessage}</div>
    {/if}
  </form>
  
  <div 
    class="forgot-password" 
    on:click={handleForgotPassword}
    on:keydown={handleForgotPasswordKeydown}
    tabindex="0"
    role="button"
  >
    Pamiršau slaptažodį
  </div>
</div>
